import { useQuery } from '@tanstack/react-query';

import { newsQueryOptions } from '@lib/query/options/cms';
import Breadcrumbs from '@modules/common/components/breadcrumbs';
import Container from '@modules/common/components/container';
import LatestNews from '@modules/home/components/latest-news';

const breadcrumbsItems = [
  { name: '首頁', href: '/' },
  { name: '最新消息', href: '' },
];

export default function LatestPage() {
  const { data: news, isLoading, error, refetch } = useQuery(newsQueryOptions);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex justify-center py-12">
          <div className="text-grey-10">載入中...</div>
        </div>
      );
    }

    if (error) {
      // Note: This log may be called multiple times in development due to React Strict Mode.
      // This is acceptable because: 1) It only affects development, 2) The duplication helps
      // identify re-render issues, 3) Moving to useEffect would add complexity without benefit.
      console.error('[LatestPage] Failed to fetch news:', error);
      return (
        <div className="flex flex-col items-center justify-center gap-4 py-12">
          <div className="text-red-500">載入失敗，請稍後再試</div>
          <button
            onClick={() => refetch()}
            className="text-primary-30 underline"
          >
            重新載入
          </button>
        </div>
      );
    }

    return <LatestNews news={news ?? { docs: [], nextPage: null }} />;
  };

  return (
    <Container className="mb-[75px] mt-12 flex flex-col gap-12">
      <Breadcrumbs items={breadcrumbsItems} />
      {renderContent()}
    </Container>
  );
}
